







import Vue from 'vue'
import { ThisTypedComponentOptionsWithRecordProps } from 'vue/types/options'
import UiButton from '@/components/ui/UiButton.vue'

interface Data {}

interface Methods {}

interface Computed {}

interface Props {}

export default Vue.extend({
  name: 'CalculatorPlug',
  components: {
    UiButton
  }
} as ThisTypedComponentOptionsWithRecordProps<Vue, Data, Methods, Computed, Props>)
